<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4">
          <div
            class="card-header pb-0 d-flex justify-content-between align-items-center"
          >
            <h6>品牌列表</h6>
            <button
              class="btn btn-sm btn-success mb-0"
              @click="$router.push('/brands/new')"
              v-if="can('product.create')"
            >
              新增品牌
            </button>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      品牌
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                    >
                      代稱
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      排序
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      選單可見
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      狀態
                    </th>
                    <th class="text-secondary opacity-7"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="brand in brands" :key="brand.id">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div>
                          <img
                            :src="brand.logo_url || '/no-image.png'"
                            class="avatar avatar-sm me-3 border-radius-lg"
                            alt="brand"
                          />
                        </div>
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ brand.name }}</h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <p class="text-xs font-weight-bold mb-0">
                        {{ brand.slug }}
                      </p>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">{{
                        brand.menu_order || 0
                      }}</span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span
                        class="badge badge-sm"
                        :class="
                          brand.show_in_menu
                            ? 'bg-gradient-info'
                            : 'bg-gradient-secondary'
                        "
                      >
                        {{ brand.show_in_menu ? "顯示" : "隱藏" }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <soft-badge
                        :color="brand.is_active ? 'success' : 'secondary'"
                        variant="gradient"
                        size="sm"
                      >
                        {{ brand.is_active ? "啟用" : "停用" }}
                      </soft-badge>
                    </td>
                    <td class="align-middle">
                      <a
                        href="javascript:;"
                        class="text-info font-weight-bold text-xs me-3"
                        data-toggle="tooltip"
                        data-original-title="Sort products"
                        @click="openSortModal(brand)"
                        v-if="can('product.edit')"
                      >
                        商品順序
                      </a>
                      <a
                        href="javascript:;"
                        class="text-secondary font-weight-bold text-xs me-3"
                        data-toggle="tooltip"
                        data-original-title="Edit brand"
                        @click="$router.push(`/brands/${brand.id}/edit`)"
                        v-if="can('product.edit')"
                      >
                        編輯
                      </a>
                      <a
                        href="javascript:;"
                        class="text-danger font-weight-bold text-xs"
                        data-toggle="tooltip"
                        data-original-title="Delete brand"
                        @click="deleteBrand(brand.id)"
                        v-if="can('product.delete')"
                      >
                        刪除
                      </a>
                    </td>
                  </tr>
                  <tr v-if="brands.length === 0">
                    <td colspan="6" class="text-center py-4 text-secondary">
                      暫無資料
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Sort Modal -->
    <div
      v-if="showSortModal"
      class="modal fade show d-block"
      style="background: rgba(0, 0, 0, 0.5)"
    >
      <div class="modal-dialog modal-lg modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              調整產品順序 - {{ selectedBrandForSort?.name }}
            </h5>
            <button
              type="button"
              class="btn-close"
              @click="closeSortModal"
            ></button>
          </div>
          <div class="modal-body">
            <GenericProductSorter
              v-if="selectedBrandForSort"
              :fetch-params="{ brand_id: selectedBrandForSort.id }"
              save-url="/api/admin/products/reorder"
              @close="closeSortModal"
              @saved="fetchBrands"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SoftBadge from "@/components/SoftBadge.vue";
import request from "@/utils/request";
import { hasPermission } from "@/utils/permissions";
import GenericProductSorter from "@/components/GenericProductSorter.vue";

export default {
  name: "brands-table",
  components: {
    SoftBadge,
    GenericProductSorter,
  },
  data() {
    return {
      brands: [],
      currentUser: JSON.parse(localStorage.getItem("user") || "{}"),
      showSortModal: false,
      selectedBrandForSort: null,
    };
  },
  methods: {
    can(permission) {
      return hasPermission(this.currentUser, permission);
    },
    async fetchBrands() {
      try {
        const response = await request.get("/api/admin/brands");
        this.brands = response.data.data;
      } catch (error) {
        console.error("Failed to fetch brands", error);
      }
    },
    openSortModal(brand) {
      this.selectedBrandForSort = brand;
      this.showSortModal = true;
    },
    closeSortModal() {
      this.showSortModal = false;
      this.selectedBrandForSort = null;
    },
    async deleteBrand(id) {
      this.$swal({
        title: "確定要刪除此品牌嗎？",
        text: "此操作無法復原",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ea0606",
        confirmButtonText: "確定刪除",
        cancelButtonText: "取消",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await request.delete(`/api/admin/brands/${id}`);
            this.fetchBrands(); // Refresh list
            this.$swal.fire("已刪除", "品牌已成功刪除。", "success");
          } catch (error) {
            console.error("Failed to delete brand", error);
            this.$swal.fire("錯誤", "刪除失敗", "error");
          }
        }
      });
    },
  },
  async created() {
    this.fetchBrands();
  },
};
</script>
